import React, { Fragment, useEffect, useState } from 'react'
import { Col, Row } from 'reactstrap'
import SideBar from '../../components/SideBar'
import { FaUserLarge, FaTruckField, FaFile } from 'react-icons/fa6'
import { Link } from 'react-router-dom'

import Header from '../../components/DataManagement/Header'
import { getDashboardStatsApi } from '../../api/dashboard'

const REGISTRIES = [
    {
        key: 'vehicles',
        label: 'Flotte',
        unit: 'véhicules validés',
        icon: <FaTruckField />,
        link: '/admin/floatTable',
    },
    {
        key: 'drivers',
        label: 'Chauffeurs',
        unit: 'chauffeurs actifs',
        icon: <FaUserLarge />,
        link: '/admin/responsableTable',
    },
    {
        key: 'documents',
        label: 'Documents',
        unit: 'documents validés',
        icon: <FaFile />,
        link: '/admin/documentTable',
    },
]

function DataManagement() {
    const [registryStatus, setRegistryStatus] = useState(null)
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        getStats()
    }, [])

    const getStats = async () => {
        try {
            setIsLoading(true)

            const response = await getDashboardStatsApi()

            if (response && response.registryStatus) {
                setRegistryStatus(response.registryStatus)
            }
        }
        catch(err) {
            // the registry links below still work without live counts
        }
        finally {
            setIsLoading(false)
        }
    }

  return (
    <section className='dataManagement'>
        <Row>
            <Col md="2" className="p-0">
                <SideBar />
            </Col>
            <Col md="10" className="p-0">
                <Header />

                <div className="pageContents">
                    <div className="registryGrid">
                        {REGISTRIES.map(reg => {
                            const counts = registryStatus?.[reg.key]
                            const total = counts ? counts.nouveau + counts.valide + counts.annule : 0

                            return (
                                <Link to={reg.link} className="registryCard" key={reg.key}>
                                    <span className="registryIcon">{reg.icon}</span>
                                    <span className="registryLabel">{reg.label}</span>

                                    {!isLoading && counts && (
                                        <Fragment>
                                            <span className="registryCount">{counts.valide}</span>
                                            <span className="registryUnit">{reg.unit}</span>

                                            {total > 0 && (
                                                <div className="registryBar">
                                                    <div className="seg seg-nouveau" style={{ width: `${(counts.nouveau / total) * 100}%` }}></div>
                                                    <div className="seg seg-valide" style={{ width: `${(counts.valide / total) * 100}%` }}></div>
                                                    <div className="seg seg-annule" style={{ width: `${(counts.annule / total) * 100}%` }}></div>
                                                </div>
                                            )}

                                            {counts.nouveau > 0 && (
                                                <span className="registryPending">{counts.nouveau} en attente de validation</span>
                                            )}
                                        </Fragment>
                                    )}

                                    <span className="registryLink">Voir le registre →</span>
                                </Link>
                            )
                        })}
                    </div>
                </div>
            </Col>
        </Row>
    </section>
  )
}

export default DataManagement
